'use client';

import Image from 'next/image';

const PRIZES_CDN_BASE = 'https://ocnc-fantasy.s3.eu-west-1.amazonaws.com/prizes/cdm';

const endPrizeRows: { title: string; description: string; imageSrc: string }[] = [
  {
    title: '2 sauts en tandem à Skydive Spa',
    description:
      "Envie de repousser vos limites ? Il n'y a pas d'âge pour les sensations fortes : sautez en parachute ! Le Skydive Spa, spécialisé dans les sauts en tandem, vous promet des émotions intenses à plus de 4000 mètres d'altitude.\n\nN'attendez plus, décollez pour un moment inoubliable et vivez la meilleure expérience possible !",
    imageSrc: `${PRIZES_CDN_BASE}/skydive-spa.jpg`,
  },
  {
    title: '2 x 2 vols pour Flyin Liège',
    description:
      "À 10 minutes de Liège, découvrez un concept de loisir original : l'un des plus larges simulateurs de chute libre au monde ! Sa soufflerie circulaire propulse l'air à plus de 300 km/h.\n\nConfort unique et sensations garanties, tant pour un baptême de l'air que pour les professionnels. Flyin vous fera vraiment décoller !",
    imageSrc: `${PRIZES_CDN_BASE}/flyinn-liege.jpg`,
  },
  {
    title: '2 entrées aux Grottes de Remouchamps',
    description:
      "Explorez les Grottes de Remouchamps et leurs galeries spectaculaires façonnées par la nature, dont la Cathédrale, une salle haute de 40 mètres ! Le clou du spectacle ? Le retour en bateau sur la rivière souterraine.\n\nVous profiterez ainsi de la plus longue navigation souterraine d'Europe accessible aux touristes. Magique et mystérieux.",
    imageSrc: `${PRIZES_CDN_BASE}/grottes-de-remouchamps.jpg`,
  },
  {
    title: '5 sessions de 15 minutes de karting chez JM Karting',
    description:
      "Prenez le volant de karts performants et sécurisés, propulsés à plus de 50 km/h ! Équipés de ceintures ajustables et d'un système électronique de contrôle de vitesse à distance, ces karts garantissent un fun maximum en toute sécurité.\n\nPrêt à défier le chrono et à faire parler votre fougue sur la piste ? À vos marques !",
    imageSrc: `${PRIZES_CDN_BASE}/karting-floreffe.jpg`,
  },
  {
    title: '2 x 4 parties de Battlekart au Wex KO',
    description:
      "BattleKart allie les sensations réelles du karting et le fun de la réalité augmentée. À bord d'un vrai kart, évoluez dans un environnement projeté.\n\nMarquez un max de points et freinez vos adversaires grâce aux bonus virtuels récupérés sur la piste. Vous ne jouez pas au jeu vidéo, vous êtes dans le jeu vidéo ! Dépassez la réalité !",
    imageSrc: `${PRIZES_CDN_BASE}/battlekart.jpg`,
  },
  {
    title: "10 x 2 entrées au Natura Parc aux Lacs de l'Eau d'Heure",
    description:
      "Situé au coeur de la nature, Natura Parc est un parc aventure unique en Wallonie. Au programme : 10 parcours accrobranche, des tyroliennes géantes au-dessus du lac, un saut pendulaire et des Explor'Games.\n\nEn famille ou entre amis, profitez d'une panoplie d'activités sur les berges du plus beau lac de Belgique. Laissez-vous séduire !",
    imageSrc: `${PRIZES_CDN_BASE}/natura-parc.jpg`,
  },
];

function PrizeArticle({ title, description, imageSrc }: { title: string; description: string; imageSrc: string }) {
  return (
    <article className="overflow-hidden rounded-lg bg-white shadow-[0px_2px_8px_rgba(0,0,0,0.04)]">
      <div className="relative aspect-square w-full bg-[var(--light,#f0f5f9)]">
        <Image
          src={imageSrc}
          alt={title}
          fill
          className="object-cover"
          sizes="(max-width: 640px) 100vw, 384px"
        />
      </div>
      <div className="space-y-2 p-5">
        <h3 className="text-[16px] font-semibold text-[var(--rtbf-blue,#0076A9)]">{title}</h3>
        <div className="space-y-3">
          {description
            .split(/\n\n+/)
            .map((paragraph) => paragraph.trim())
            .filter(Boolean)
            .map((paragraph, index) => (
              <p key={index} className="text-[14px] font-normal leading-relaxed text-[var(--rtbf-dark,#001425)]">
                {paragraph}
              </p>
            ))}
        </div>
      </div>
    </article>
  );
}

export default function PrizesPage() {
  return (
    <div className="min-h-[calc(100vh-100px)] bg-[var(--rtbf-dark,#001425)] px-3 pb-20 pt-6 sm:px-4">
      <div className="mx-auto w-full max-w-3xl">
        <section className="space-y-8 py-1 sm:py-0">
          <div className="space-y-3">
            <h1 className="text-[22px] font-semibold leading-tight text-white sm:text-[24px]">Prix</h1>
            <h2 className="text-[18px] font-semibold text-white">Prix finaux du classement général</h2>
            <p className="text-[14px] font-normal leading-relaxed text-white/85">
              À la fin de la Coupe du monde de football, sur base du classement final, les prix finaux suivants seront attribués :
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            {endPrizeRows.map((row) => (
              <PrizeArticle
                key={row.title}
                title={row.title}
                description={row.description}
                imageSrc={row.imageSrc}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
